import { Skeleton } from "@/shared/ui";

export default function ChatPageSkeleton() {
  return (
    <div className="flex-1 grid grid-cols-[1fr_3fr] min-h-0 radius-lg overflow-hidden border surface-base-stroke">
      <div className="flex flex-col surface-base-fill border-r surface-base-stroke">
        <div className="px-4 py-3 border-b surface-base-stroke">
          <Skeleton width={100} height={24} />
        </div>
        <div className="p-2 flex flex-col gap-1">
          {Array.from({ length: 4 }, (_, i) => (
            <div key={i} className="flex items-center gap-3 px-3 py-2.5">
              <Skeleton width={40} height={40} borderRadius={8} />
              <Skeleton width="70%" height={18} />
            </div>
          ))}
        </div>
      </div>
      <div className="flex flex-col">
        <div className="px-6 py-3 border-b surface-base-stroke">
          <Skeleton width={200} height={24} />
        </div>
        <div className="flex-1 p-4">
          <Skeleton height="100%" borderRadius={8} />
        </div>
      </div>
    </div>
  );
}
